import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    formControl: {
      margin: theme.spacing(1)
    },
    marginLeft: {
      marginLeft: theme.spacing(1)
    },
    dialogHeaderFooter: {
      background: colors.defaultGrey
    },
    dialog: {
      overflow: 'hidden'
    },
    updateForm: {
      minWidth: 250,
      justifyContent: 'center'
    }
  });
});
